import { render, staticRenderFns } from "./Universe.vue?vue&type=template&id=2dcef363&scoped=true"
import script from "./Universe.vue?vue&type=script&lang=js"
export * from "./Universe.vue?vue&type=script&lang=js"
import style0 from "./Universe.vue?vue&type=style&index=0&id=2dcef363&prod&scoped=true&lang=css"
import style1 from "./Universe.vue?vue&type=style&index=1&id=2dcef363&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcef363",
  null
  
)

export default component.exports